import styles from "./StatusPage.module.scss";
import { background } from "../assets/images";
import { Layout } from "../shared/components/Layout";
import { ServerStatusDino } from "../features/server-status/ServerStatusDino";
import { useServersStore } from "../shared/store/serversStore";
import { StatusPopup } from "../shared/components/StatusPopup";
import StatusGallery from "../features/server-status/StatusGallery";

const ServerStatusPage = () => {
  const { selectedServer, serverStatus, selectError, checkServerStatus } =
    useServersStore();

  const handleRetry = () => {
    if (selectedServer) {
      checkServerStatus(selectedServer.id, true);
    }
  };

  return (
    <Layout
      customMainClass={styles.statusMain}
      background={background}
      customPlaceholder={styles.placeholder}
      showFooter
    >
      <StatusGallery />
      {selectError && (
        <StatusPopup
          title="Ошибка"
          mode="error"
          errorMessage={selectError}
          onRetry={handleRetry}
        />
      )}
      <ServerStatusDino status={serverStatus || "server-error"} />
    </Layout>
  );
};
export default ServerStatusPage;
